import {
  getServices,
  createService,
  updateService,
  updateServices,
  createServices,
} from 'lib/api';
import {
  SERVICES_ACTIONS,
  ServiceQueryParams,
  CreateParams,
  ServiceItem,
  UpdateServiceParams,
} from '.';

const {
  GET_SERVICES_START,
  GET_SERVICES_ERROR,
  GET_SERVICES_SUCCESS,
  ADD_SERVICE_START,
  ADD_SERVICE_ERROR,
  ADD_SERVICE_SUCCESS,
  ADD_SERVICES_START,
  ADD_SERVICES_ERROR,
  ADD_SERVICES_SUCCESS,
  EDIT_SERVICE_START,
  EDIT_SERVICE_ERROR,
  EDIT_SERVICE_SUCCESS,
  EDIT_SERVICES_START,
  EDIT_SERVICES_ERROR,
  EDIT_SERVICES_SUCCESS,
} = SERVICES_ACTIONS;

export const loadServices = async ({
  size,
  page,
  sort,
  search,
  filterByActive,
  dispatch,
}: ServiceQueryParams): Promise<void> => {
  dispatch({ type: GET_SERVICES_START });

  const response = await getServices({
    start: page,
    limit: size,
    search: search,
    filterByActive: filterByActive,
    sort: sort,
  }).catch(err => err);
  if (response instanceof Error) {
    dispatch({
      type: GET_SERVICES_ERROR,
      error: response.message,
    });
    return;
  }
  dispatch({
    type: GET_SERVICES_SUCCESS,
    payload: {
      services: response.services,
      count: response.count,
    },
  });
};

export const addService = async ({
  data,
  dispatch,
}: CreateParams): Promise<ServiceItem | undefined> => {
  dispatch({ type: ADD_SERVICE_START });

  const service: ServiceItem = await createService({ data }).catch(err => err);

  if (service instanceof Error) {
    dispatch({
      type: ADD_SERVICE_ERROR,
      error: service.message,
    });
    return;
  }

  dispatch({
    type: ADD_SERVICE_SUCCESS,
    payload: {
      service,
    },
  });

  return service;
};

export const addServices = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: ADD_SERVICES_START });

  const services = await createServices({ data }).catch(err => err);
  if (services instanceof Error) {
    dispatch({
      type: ADD_SERVICES_ERROR,
      error: services.message,
    });
    return;
  }
  const payload = {
    services,
    data,
  };
  dispatch({ type: ADD_SERVICES_SUCCESS, payload });
};

export const editService = async (
  params: UpdateServiceParams
): Promise<object> => {
  const { data, dispatch, serviceId } = params;
  dispatch({ type: EDIT_SERVICE_START });
  const service = await updateService({
    serviceId,
    data,
  }).catch(err => err);
  if (service instanceof Error) {
    dispatch({
      type: EDIT_SERVICE_ERROR,
      error: service.message,
    });
    return {};
  }
  dispatch({
    type: EDIT_SERVICE_SUCCESS,
    payload: {
      serviceId,
      service,
    },
  });
  return service;
};

export const editServices = async ({
  data,
  dispatch,
}: CreateParams): Promise<void> => {
  dispatch({ type: EDIT_SERVICES_START });

  const services = await updateServices({ data }).catch(err => err);
  if (services instanceof Error) {
    dispatch({
      type: EDIT_SERVICES_ERROR,
      error: services.message,
    });
    return;
  }
  const payload = {
    services,
    data,
  };
  dispatch({ type: EDIT_SERVICES_SUCCESS, payload });
};
